import React from 'react';
import { CircuitRenderer, CircuitElement } from './CircuitRenderer';

interface RLCircuitDiagramProps {
    voltage: number;
    resistance: number;
    inductance: number;
}

export const RLCircuitDiagram: React.FC<RLCircuitDiagramProps> = ({
    voltage,
    resistance,
    inductance
}) => {
    // Series RL Circuit
    // (V) --- [R] --- (L) --- |
    //  |                      |
    //  -----------------------|

    const width = 450;
    const height = 300;
    const padding = 50;

    const leftX = padding + 40;
    const rightX = width - padding - 40;
    const topY = padding + 20;
    const bottomY = height - padding - 20;

    const elements: CircuitElement[] = [
        // Voltage Source
        {
            type: 'voltageSource',
            from: { x: leftX, y: bottomY },
            to: { x: leftX, y: topY },
            value: voltage,
            labelSide: 'left'
        },

        // Top Resistor
        {
            type: 'resistor',
            from: { x: leftX, y: topY },
            to: { x: rightX, y: topY },
            value: resistance,
            label: `R=${resistance}Ω`,
            labelSide: 'left'
        },

        // Right Inductor
        {
            type: 'inductor',
            from: { x: rightX, y: topY },
            to: { x: rightX, y: bottomY },
            value: inductance,
            label: `L=${inductance}mH`,
            labelSide: 'left'
        },

        // Bottom Wire
        {
            type: 'wire',
            from: { x: rightX, y: bottomY },
            to: { x: leftX, y: bottomY },
            labelSide: 'left'
        }
    ];

    return (
        <CircuitRenderer width={width} height={height} elements={elements} />
    );
};
